import script from "./DeckInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./DeckInfo.vue?vue&type=script&setup=true&lang=js"

import "./DeckInfo.vue?vue&type=style&index=0&id=7ebe33e0&lang=css"

const __exports__ = script;

export default __exports__